import { render } from "./SessionsTruncate.vue?vue&type=template&id=a4dd06d2"
import script from "./SessionsTruncate.vue?vue&type=script&lang=js"
export * from "./SessionsTruncate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__